import { render, staticRenderFns } from "./PCamera.vue?vue&type=template&id=931e0fd0&"
import script from "./PCamera.vue?vue&type=script&lang=js&"
export * from "./PCamera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports